import React from "react"
import styled from "@emotion/styled"

import ButtonLink from "../global/ButtonLink"
import Image from "../global/Image"

const Outer = styled.div`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  width: 100%;
  padding: 96px 0;
  align-items: center;
  background: ${props =>
    props.backgroundColorOverride
      ? props.backgroundColorOverride
      : "transparent"};
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2 / 3;
  align-items: center;
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    display: grid;
    gap: 80px;
    grid-auto-flow: dense;
    grid-template-columns: ${props =>
      props.reverse ? "1fr 1.5fr" : "1.5fr 1fr"};
  }
`
const MediaFeatureImage = styled.div`
  width: 100%;
  margin-top: auto;
  margin-bottom: auto;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    margin-bottom: 16px;
  }
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    grid-column: ${props => (props.reverse ? "1" : "2")};
  }
`
const MediaFeatureText = styled.div`
  width: 100%;
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    grid-column: ${props => (props.reverse ? "2" : "1")};
  }
`

const PostCardContainer = styled.div`
  grid-column: 1/-1;
  display: grid;
  gap: 32px;
  max-width: 640px;
  margin: 64px auto 0 auto;
  text-align: center;
  p {
    margin: 0 auto;
    max-width: 480px;
  }
`

const ButtonContainer = styled.div`
  margin: 0 auto;
`

export default function MediaFeature({
  backgroundColorOverride,
  reverse,
  src,
  alt,
  children,
  cta,
}) {
  return (
    <Outer backgroundColorOverride={backgroundColorOverride}>
      <Inner reverse={reverse}>
        <MediaFeatureImage reverse={reverse}>
          <Image src={src} alt={alt} />
        </MediaFeatureImage>
        <MediaFeatureText reverse={reverse}>{children}</MediaFeatureText>

        {cta && (
          <PostCardContainer>
            <p>
              Discover what we typically explore and test during a remote,
              in-depth user testing session.
            </p>
            <ButtonContainer>
              <ButtonLink
                to="/our-user-testing/"
                backgroundColorOverride={props => props.theme.primary}
              >
                Our user testing
              </ButtonLink>
            </ButtonContainer>
          </PostCardContainer>
        )}
      </Inner>
    </Outer>
  )
}
